import { render, staticRenderFns } from "./VariantsSkeletonLoader.vue?vue&type=template&id=12fbe178&scoped=true&"
import script from "./VariantsSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./VariantsSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./VariantsSkeletonLoader.vue?vue&type=style&index=0&id=12fbe178&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fbe178",
  null
  
)

export default component.exports